export default __webpack_public_path__ + "img/deposit.d0ab9df.svg";